import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Layout } from '@bingads-webui-react/wizard';
import { STORE_TYPE_TO_FLOW } from '@bingads-webui-campaign-react/unified-app-shared';
import { withSiteMap, getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { withScope } from '@bingads-webui-react/scope-service';

import { UnifiedAppEditAssetGroupSettingsStepConfig } from '../steps/step-config';
import { EditFooter } from '../components';
import { STEP_PATHS, UNIFIED_APP_EDIT_ASSET_GROUP_SETTINGS_WIZARD_ID } from '../steps/step-constants';
import { useCampaignStoreType } from './use-store-type';
import { UnifiedAppWizard } from './wizard';

const UnifiedAppEditAssetGroupSettingsWizardInternal = ({
  currentCampaign, perfMarker, siteMap, scope,
}) => {
  const storeType = useCampaignStoreType(currentCampaign);
  const wizardFlow = useMemo(() => STORE_TYPE_TO_FLOW[storeType], [storeType]);

  const routeToNavigateToWhenDone = getRoutePathById(siteMap, 'appads-asset-groups');

  const { assetGroupId } = scope.values;

  const config = useMemo(() => ({
    id: UNIFIED_APP_EDIT_ASSET_GROUP_SETTINGS_WIZARD_ID,
    initialStep: STEP_PATHS.ASSETS_GROUP_EDIT,
    steps: UnifiedAppEditAssetGroupSettingsStepConfig,
    initialFlowFactors: { flow: wizardFlow },
    initialWizardData: {
      campaign: currentCampaign,
      assetGroup: { Id: assetGroupId },
      flow: wizardFlow,
    },
    actions: {
      onDone: () => scope.save(routeToNavigateToWhenDone),
      onExited: () => scope.save(routeToNavigateToWhenDone),
    },
  }), [currentCampaign, routeToNavigateToWhenDone, scope, assetGroupId, wizardFlow]);

  return (
    <UnifiedAppWizard
      action="AssetGroupSettings"
      storeType={storeType}
      wizardConfig={config}
      scope={scope}
      perfMarker={perfMarker}
    >
      <Layout type="Footer" component={EditFooter} />
    </UnifiedAppWizard>
  );
};

UnifiedAppEditAssetGroupSettingsWizardInternal.propTypes = {
  currentCampaign: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    save: PropTypes.func.isRequired,
    values: PropTypes.shape({
      assetGroupId: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  perfMarker: PropTypes.shape({
    createChild: PropTypes.func.isRequired,
  }).isRequired,
  siteMap: PropTypes.shape({}).isRequired,
};

export const UnifiedAppEditAssetGroupSettingsWizard = withScope(withSiteMap(UnifiedAppEditAssetGroupSettingsWizardInternal));
